import { proceedOnEstimateConstants } from '../constants/actionTypes'
import * as proceedEstimateService from '../services/proceedEstimateService'

import { API_URL } from '../constants/config'
import { query } from '../services/utilities'
import { SetApplicationRole } from '../actions/applicationRoleActions'
//import { WaitOnProceedEstimateSubmission, OnProceedWithEstimateSubmission, WaitOnCancelProceedEstimateSubmission, OnCancelEstimateSubmission} from 'src/actions/proceedEstimateActions'
import { applicationRoles } from '../constants/actionTypes'
import { COMMON_ERROR_MESSAGE } from '../constants/messages'

export const OnProceedWithEstimate = (oppurtunityId, estimateId, history) => {
  return (dispatch) => {
    return proceedEstimateService.OnProceedWithEstimate(
      oppurtunityId,
      estimateId,
      dispatch,
      history
    )
  }
}

export const WaitOnProceedEstimateSubmission = () => {
  return {
    type: proceedOnEstimateConstants.PROCEED_ESTIMATE_SUBMITTING,
  }
}

export const OnProceedWithEstimateSubmission = (didSubmit, response) => {
  switch (didSubmit) {
    case true:
      return {
        type: proceedOnEstimateConstants.PROCEED_ESTIMATE_SUCCESS,
        payload: response,
      }
    case false:
      return {
        type: proceedOnEstimateConstants.PROCEED_ESTIMATE_FAILED,
        payload: response,
      }
  }
}

export const OnCancelSelectedEstimate = (
  opportunityId,
  estimateId,
  dispatch
) => {
  //return dispatch => {
  //proceedEstimateService.OnCancelSelectedEstimate(oppurtunityId, estimateId)
  //}
  let inputDetails = {
    isIndicative: false,
    quoteId: estimateId,
  }
  dispatch(WaitOnCancelProceedEstimateSubmission())
  query(`${API_URL}/opportunity/${opportunityId}/proposal/indicative/oly`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(inputDetails),
  }).then(
    (data) => {
      dispatch(SetApplicationRole(applicationRoles.USER_WITH_ESTIMATES))
      dispatch(OnCancelEstimateSubmission(true))
    },
    (error) => {
      if (!isNaN(error)) {
        error = COMMON_ERROR_MESSAGE
      }
      dispatch(OnCancelEstimateSubmission(false, error))
    }
  )
}

export const WaitOnCancelProceedEstimateSubmission = () => {
  return {
    type: proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_SUBMITTING,
  }
}

export const OnCancelEstimateSubmission = (didSubmit, response) => {
  switch (didSubmit) {
    case true:
      return {
        type: proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_SUCCESS,
        payload: response,
      }
    case false:
      return {
        type: proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_FAILED,
        payload: response,
      }
  }
}

export const ResetProceedEstimateErrorMessage = () => {
  return {
    type: proceedOnEstimateConstants.RESET_PROCEED_ESTIMATE_ERROR_MESSAGE,
  }
}
